import React from "react";
import styles from "./HeaderSearch.module.scss";
import {useTranslation} from "react-i18next";

type PrevSearchItemType = {
  term: string;
  searchPrevSearchItem: (query: string) => void;
  removePrevSearchItem: (query: string) => void;
};

const PrevSearchItem: React.FC<PrevSearchItemType> = ({removePrevSearchItem, searchPrevSearchItem, term}) => {
  const {t} = useTranslation();

  return (
    <div className={`${styles.suggestItem} ${styles.suggestItemStored}`}>
      <button
        className={styles.suggestItemStoredLink}
        onClick={() => searchPrevSearchItem(term)}
        type="button"
        aria-label={t("search.searchAgain--query", {query: term})}
        title={t("search.searchAgain--query", {query: term})}
      >
        <span className={styles.suggestItemStoredIdentifier}>
          <i className="icon icon-clock icon-size--20" />
        </span>
        <span>{term}</span>
      </button>
      <button
        className={styles.suggestItemStoredRemove}
        onClick={() => removePrevSearchItem(term)}
        type="button"
        aria-label={t("search.deleteSearchTerm")}
        title={t("search.deleteSearchTerm")}
      >
        <i className={`icon icon-close icon-size--22 ${styles.fieldButtonRemoveIcon}`} />
      </button>
    </div>
  );
};

export default PrevSearchItem;
